import React, { Component } from 'react';
import App from "../../App";
import Loader from 'react-loader';
import { Link, withRouter } from "react-router-dom";
import Pagination from 'react-js-pagination';
import { toast } from 'react-toastify';
import { getPaginatedList,  destroy } from "../../services/baseServices";
import { humanize } from "../../helper/utils"

class List extends Component {
    constructor() {
        super();
        this.state = {
            raList: [],
            activePage: 1,
            per_page: 15,
            page: 1,
            temp_params: {},
            query_params: {},
            loading: false
        };
    }
    
    getQueryParams = () => {
        let params = Object.assign(this.state.query_params, {per_page: this.state.per_page, page: this.state.page});
        return params;
      }

    getPaginatedRAs = (params) => {
        this.setState({loading: true})
        getPaginatedList("retailer_assistants", params)
        .then(res => {
            this.setState({ 
                raList: res?.data?.data,
                per_page: res.headers['x-per-page'],
                total_data: res.headers['x-total'],
                loading: false
            })
          })
        .catch(errMsg => {
            this.setState({loading: false})
        })
      }

      handleOnFieldChange = (e) => {
        const queryData = {...this.state.temp_params};
        queryData[e.target.name] = e.target.value;
        this.setState({temp_params: queryData}, () => {
        });
      }

      handleOnSearch = (e) => {
        e.preventDefault();
        const tempParam = this.state.temp_params;
          this.setState({per_page: 50, page: 1, query_params: tempParam, isLoading:true}, () => {
            this.getPaginatedRAs(this.state.temp_params);
          });
      }

      handlePageChange = (pageNumber) => {
        this.setState({page: pageNumber, activePage: pageNumber}, () => {
          this.getPaginatedRAs(this.getQueryParams());
        });
      }

    componentDidMount() {
        this.getPaginatedRAs(this.getQueryParams())
    }

    render() {
        return(
            <App layout={''}>
                <div className="main-content">
                    <div className="page-header">
                        <h2 className="page-title">RA List</h2>
                    </div>
                    <div className="card-block">
                        <div className="block-body">
                            <Loader loaded={!this.state.loading}>
                                <table className="order-table table table-striped">
                                    <thead>
                                    <tr>
                                        <th style={{width: '20px'}}>#</th>
                                        <th>Name</th>
                                        <th>Phone</th>
                                        <th>Email</th>
                                        <th>Category</th>
                                        <th>Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.raList && this.state.raList?.map((ra, index) => {
                                        return ( 
                                            <tr key={index}>
                                                <td>{((this.state.page - 1) * this.state.per_page) + index + 1}</td>
                                                <td className='text-break'>
                                                    <Link to={`${process.env.PUBLIC_URL}/ra/details/${ra.id}`}>{ra.name}</Link>
                                                </td>
                                                <td>
                                                    {ra.phone}
                                                </td>
                                                <td className='text-break'>{ra.email}</td>
                                                <td>{humanize(ra.category)}</td>
                                                <td>{ra.status}</td>
                                            </tr>
                                        )
                                        })
                                    }
                                    </tbody>
                                </table>
                                <div className="mt-3">
                                    <Pagination
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={this.state.per_page}
                                        totalItemsCount={this.state.total_data}
                                        pageRangeDisplayed={10}
                                        onChange={this.handlePageChange.bind(this)}
                                        />
                                </div>
                            </Loader>
                        </div>
                    </div>

                </div>
            </App>
        )
    }
}

export default withRouter(List);